module.exports = __webpack_public_path__ + "img/cd32e8f.jpg";